/**
 * Which step of the email-first login flow (SYRC-6097) is on screen.
 *
 * Kept in its own file rather than inline in login.component.ts so the flow's
 * states are a standalone, importable type.
 */
export enum LoginStep {
  /** Step 1 — collect the email address. */
  EmailEntry = 'email-entry',
  /** Step 2 — email resolved; show the available sign-in options. */
  ConfirmIdentity = 'confirm-identity',
}
